import { z } from "zod";

export const handoverSchema = z.object({
  contacts: z
    .array(z.object({ email: z.string().email() }))
    .min(1)
    .max(5),
  displayAfterNbMsg: z.number().min(0).max(10),
  email: z.object({
    introduction: z.string().min(1).max(256),
    sendButton: z.string().min(1).max(32),
    title: z.string().min(1).max(128),
  }),
  form: z.object({
    emailLabel: z.string().min(1).max(32),
    inquiryPlaceholder: z.string().min(1).max(64),
    introduction: z.string().min(1).max(256),
    submit: z.string().min(1).max(36),
  }),
  workflow: z.object({
    id: z.string().min(16).max(16),
  }),
});

export type Handover = z.infer<typeof handoverSchema>;

export const handoverNestedSchema = z.object({ handover: handoverSchema.nullish() });
export type HandoverNested = z.infer<typeof handoverNestedSchema>;
